<template>
	<div class="zhu">
		<!-- 注册弹窗 -->
		<div class="modal-dialog">
			<div class="dialog-header">
				<h3>用户注册</h3>
				<button class="close-btn" @click="handleClose">×</button>
			</div>

			<div class="dialog-body">
				<form class="register-form">

					<div class="form-item">
						<label class="form-label">用户名</label>
						<div class="form-control">
							<input type="text" v-model="registerForm.username" placeholder="请输入用户名"
								@blur="validateField('username')" class="input-control">
							<span class="icon-user"></span>
							<!-- 替换：button→span，保留点击清空逻辑 -->
							<span class="clear-icon" v-if="registerForm.username"
								@click="registerForm.username = ''">×</span>
						</div>
						<p class="error-message" v-if="errors.username">{{ errors.username }}</p>
					</div>
					<div style="height: 8px;"></div>

					<div class="form-item">
						<label class="form-label">密码</label>
						<div class="form-control">
							<input :type="showPassword ? 'text' : 'password'" v-model="registerForm.password"
								placeholder="请输入密码" @blur="validateField('password')" class="input-control">
							<span class="icon-lock"></span>
							<!-- 替换：button→span，保留点击清空逻辑 -->
							<span class="clear-icon" v-if="registerForm.password"
								@click="registerForm.password = ''">×</span>
						</div>
						<p class="error-message" v-if="errors.password">{{ errors.password }}</p>
					</div>
					<div style="height: 8px;"></div>

					<div class="form-item">
						<label class="form-label">确认密码</label>
						<div class="form-control">
							<input :type="showConfirmPassword ? 'text' : 'password'"
								v-model="registerForm.confirmPassword" placeholder="请再次输入密码"
								@blur="validateField('confirmPassword')" class="input-control">
							<span class="icon-lock"></span>
							<!-- 替换：button→span，保留点击清空逻辑 -->
							<span class="clear-icon" v-if="registerForm.confirmPassword"
								@click="registerForm.confirmPassword = ''">×</span>
						</div>
						<p class="error-message" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</p>
					</div>

					<!-- 协议勾选 -->
					<div class="form-item agreement-item">
						<label class="checkbox-label">
							<input type="checkbox" v-model="agreement" @change="validateField('agreement')"
								class="custom-checkbox">
							<span class="checkbox-icon"></span>
							<span class="checkbox-text">
								我已阅读并同意<a href="javascript:void(0);" class="agreement-link"
									@click="openAgreement('user')">用户协议</a>和<a href="javascript:void(0);"
									class="agreement-link" @click="openAgreement('privacy')">隐私政策</a>
							</span>
						</label>
						<p class="error-message" v-if="errors.agreement">{{ errors.agreement }}</p>
					</div>
				</form>
			</div>

			<div class="dialog-footer">
				<button class="btn cancel-btn" @click.stop="handleClose">取消</button>
				<button class="btn primary-btn" @click.stop="handleRegister">注册</button>
			</div>
		</div>

		<!-- 协议弹窗组件 -->
		<agreement ref="agreementPopup" :isRegister="true" @confirm="handleAgreementConfirm"></agreement>
	</div>
</template>

<script>
	import {
		signserve
	} from "../../utils/request.js";
	import agreement from './Agreement.vue'; // 导入协议组件

	export default {
		name: "RegisterDialog",
		components: {
			agreement
		},
		data() {
			return {
				showPassword: false,
				showConfirmPassword: false,
				agreement: false,
				registerForm: {
					username: "",
					password: "",
					confirmPassword: ""
				},
				errors: {
					username: "",
					password: "",
					confirmPassword: "",
					agreement: ""
				}
			};
		},
		methods: {
			// 显示注册框
			show() {
				this.visible = true;
				// 重置表单
				this.$nextTick(() => {
					this.resetForm();
				});
			},

			// 关闭注册框
			handleClose() {
				this.resetForm();
				this.$emit('close')
			},

			// 重置表单
			resetForm() {
				this.registerForm = {
					username: "",
					password: "",
					confirmPassword: ""
				};
				this.agreement = false;
				this.errors = {
					username: "",
					password: "",
					confirmPassword: "",
					agreement: ""
				};
				this.showPassword = false;
				this.showConfirmPassword = false;
			},

			// 打开协议弹窗
			openAgreement(type) {
				this.$refs.agreementPopup.open(type);
			},

			// 处理协议确认
			handleAgreementConfirm() {
				this.agreement = true;
				this.validateField('agreement');
			},

			// 验证单个字段
			validateField(field) {
				switch (field) {
					case 'username':
						this.validateUsername();
						break;
					case 'password':
						this.validatePassword();
						if (this.registerForm.confirmPassword) {
							this.validateConfirmPassword();
						}
						break;
					case 'confirmPassword':
						this.validateConfirmPassword();
						break;
					case 'agreement':
						this.validateAgreement();
						break;
				}
			},

			// 验证所有字段
			validateAll() {
				let isValid = true;

				this.validateUsername();
				this.validatePassword();
				this.validateConfirmPassword();
				this.validateAgreement();

				Object.values(this.errors).forEach(error => {
					if (error) {
						isValid = false;
					}
				});

				return isValid;
			},

			// 用户名验证
			validateUsername() {
				const value = this.registerForm.username;
				if (!value) {
					this.errors.username = "请输入用户名";
					return false;
				}
				if (value.length < 2 || value.length > 20) {
					this.errors.username = "用户名长度必须在2-20个字符之间";
					return false;
				}
				const reg = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/;
				if (!reg.test(value)) {
					this.errors.username = "用户名只能包含字母、数字、下划线和汉字";
					return false;
				}
				this.errors.username = "";
				return true;
			},

			// 密码验证
			validatePassword() {
				const value = this.registerForm.password;
				if (!value) {
					this.errors.password = "请输入密码";
					return false;
				}
				if (value.length < 8 || value.length > 20) {
					this.errors.password = "密码长度必须在8-20个字符之间";
					return false;
				}

				const reg = /^(?=.*[a-z])(?=.*\d)[a-z\d]{8,20}$/;
				if (!reg.test(value)) {
					this.errors.password = "密码必须包含字母、数字";
					return false;
				}
				this.errors.password = "";
				return true;
			},

			// 确认密码验证
			validateConfirmPassword() {
				const value = this.registerForm.confirmPassword;
				if (!value) {
					this.errors.confirmPassword = "请再次输入密码";
					return false;
				}
				if (value !== this.registerForm.password) {
					this.errors.confirmPassword = "两次输入的密码不一致";
					return false;
				}
				this.errors.confirmPassword = "";
				return true;
			},

			// 协议验证
			validateAgreement() {
				if (!this.agreement) {
					this.errors.agreement = "请阅读并同意用户协议和隐私政策";
					return false;
				}
				this.errors.agreement = "";
				return true;
			},

			// 处理注册
			async handleRegister() {
				if (this.validateAll()) {
					// 模拟加载状态
					const loading = this.showLoading();
					let data = {
						username: this.registerForm.username,
						password: this.registerForm.password

					}
					let s = await signserve(data)
					// console.log(s);
					if (s.code === 200) {
						this.$toast.success('注册成功，你可以登录了！')
						this.handleClose()
					} else {
						this.$toast.error(s)
					}
					// 关闭加载（无论成功失败都关闭）
					loading.close();
				} else {
					// 滚动到第一个错误位置
					const firstError = document.querySelector('.error-message:not(:empty)');
					if (firstError) {
						firstError.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						});
					}
				}
			},

			// 显示加载状态
			showLoading() {
				// 创建加载元素
				const loading = document.createElement('div');
				loading.className = 'loading-mask';
				loading.innerHTML = `
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p class="loading-text">注册中...</p>
        </div>
      `;
				document.body.appendChild(loading);

				// 返回关闭方法
				return {
					close() {
						document.body.removeChild(loading);
					}
				};
			}
		}
	};
</script>

<!-- 样式保持不变 -->
<style lang="less" scoped>
	/* 原有样式保持不变 */
	.zhu {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 350;
		width: 100%;
		height: 100%;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
	}

	/* 弹窗容器 */
	.modal-dialog {
		position: relative;
		width: 100%;
		max-width: 400px;
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}

	/* 弹窗头部 */
	.dialog-header {
		padding: 15px 20px;
		border-bottom: 1px solid #e8e8e8;
		position: relative;

		h3 {
			margin: 0;
			font-size: 16px;
			color: #1f2329;
			font-weight: 500;
		}

		.close-btn {
			position: absolute;
			top: 15px;
			right: 20px;
			background: none;
			border: none;
			font-size: 16px;
			cursor: pointer;
			color: #909399;
			width: 20px;
			height: 20px;
			line-height: 1;
			padding: 0;

			&:hover {
				color: #409eff;
			}
		}
	}

	/* 弹窗主体 */
	.dialog-body {
		margin: 0 auto;
		padding: 20px 30px 20px 10px;
	}

	/* 表单样式 */
	.register-form {
		width: 100%;
	}

	.form-item {
		margin-bottom: 15px;
		position: relative;
		display: flex;
		align-items: center;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.form-label {
		display: inline-block;
		width: 80px;
		text-align: right;
		margin-right: 10px;
		color: #606266;
		font-size: 14px;
		flex-shrink: 0;
		/* 防止标签被压缩 */
	}

	.form-control {
		flex-grow: 1;
		/* 让输入框容器占满剩余空间 */
		position: relative;
		min-width: 0;
		/* 关键：允许容器缩小到内容尺寸 */
	}

	.input-control {
		width: 100%;
		height: 36px;
		padding: 0 15px;
		padding-right: 70px;
		/* 为右侧清除图标预留空间 */
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		font-size: 14px;
		color: #606266;
		transition: border-color 0.2s;
		box-sizing: border-box;
		/* 让内边距和边框包含在宽度内 */

		&:focus {
			border-color: #409eff;
			outline: none;
		}
	}

	/* 图标样式（用户/锁） */
	.icon-user,
	.icon-lock {
		position: absolute;
		left: 10px;
		top: 50%;
		transform: translateY(-50%);
		color: #c0c4cc;
	}

	/* 清除图标样式（核心：替换原button的交互和样式） */
	.clear-icon {
		position: absolute;
		right: 5px;
		top: 50%;
		transform: translateY(-50%);
		/* 清除默认span样式 */
		background: none;
		border: none;
		outline: none;
		/* 保持原按钮尺寸和交互 */
		width: 20px;
		height: 20px;
		line-height: 1;
		font-size: 14px;
		color: #c0c4cc;
		cursor: pointer;
		/* 确保点击区域可交互 */
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0;

		/*  hover效果与原button一致 */
		&:hover {
			color: #606266;
		}
	}

	/* 错误信息 */
	.error-message {
		position: absolute;
		left: 90px;
		top: 100%;
		margin: 5px 0 0 0;
		font-size: 12px;
		color: #f56c6c;
		height: 16px;
		line-height: 16px;
	}

	/* 协议勾选区域 */
	.agreement-item {
		margin-top: 20px;
		justify-content: flex-start;
	}

	.checkbox-label {
		display: flex;
		align-items: center;
		margin-left: 90px;
		cursor: pointer;
	}

	.custom-checkbox {
		position: absolute;
		width: 0;
		height: 0;
		opacity: 0;

		&:checked+.checkbox-icon {
			background-color: #409eff;
			border-color: #409eff;

			&::after {
				display: block;
			}
		}
	}

	.checkbox-icon {
		display: inline-block;
		width: 14px;
		height: 14px;
		border: 1px solid #dcdfe6;
		border-radius: 2px;
		position: relative;
		margin-right: 5px;

		&::after {
			content: "";
			position: absolute;
			width: 4px;
			height: 8px;
			top: 1px;
			left: 4px;
			border: 2px solid #fff;
			border-top: none;
			border-left: none;
			transform: rotate(45deg);
			display: none;
		}
	}

	.checkbox-text {
		font-size: 12px;
		color: #606266;
	}

	.agreement-link {
		color: #409eff;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	/* 弹窗底部 */
	.dialog-footer {
		padding: 10px 20px 20px;
		text-align: center;
		border-top: 1px solid #e8e8e8;
	}

	.btn {
		padding: 8px 16px;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
		transition: all 0.2s;
		border: 1px solid transparent;
		margin: 0 5px;
	}

	.cancel-btn {
		background-color: #fff;
		border-color: #dcdfe6;
		color: #606266;

		&:hover {
			background-color: #f5f7fa;
			border-color: #c0c4cc;
		}
	}

	.primary-btn {
		background-color: #409eff;
		border-color: #409eff;
		color: #fff;

		&:hover {
			background-color: #66b1ff;
			border-color: #66b1ff;
		}
	}

	/* 加载状态样式 */
	.loading-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 9999;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.loading-spinner {
		text-align: center;
	}

	.spinner {
		width: 40px;
		height: 40px;
		margin: 0 auto;
		border: 4px solid rgba(255, 255, 255, 0.2);
		border-radius: 50%;
		border-top-color: #fff;
		animation: spin 1s ease-in-out infinite;
	}

	.loading-text {
		color: #fff;
		margin-top: 10px;
		font-size: 14px;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
</style>